import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import style from './JForm.module.css'

const DonationForm = () => {

  const [formData, setFormData] = useState({
    selectedDonationAmount: null,
    customDonationAmount: "",

    sevaDate: "",
    honoureeName: "",
    relationship: "",
    donorName: "",
    email: "",
    mobile: "",
    dob: "",
    receive80G: false,
    panNumber: "",
    receiveMahaPrasadam: false,

    mahaPrasadamDetails: {
      doorNumber: "",
      houseName: "",
      streetName: "",
      area: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "customDonationAmount" && value) {
        const num = parseFloat(value);
        updatedData.selectedDonationAmount = isNaN(num) ? null : num;
      }

      return updatedData;
    });
  };

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleAmountSelect = (amount) => {
    setFormData((prevData) => ({
      ...prevData,
      selectedDonationAmount:
        prevData.selectedDonationAmount === amount ? null : amount,
      customDonationAmount: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.donorName) newErrors.donorName = "Donor name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    if (!formData.dob) newErrors.dob = "Date of birth is required";
    if (formData.receive80G && !formData.panNumber)
      newErrors.panNumber = "PAN number is required for 80G certificate";

    // Require at least one donation amount
    if (!formData.selectedDonationAmount && !formData.customDonationAmount) {
      newErrors.donationAmount =
        "Please select a donation amount or enter your own";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getTotalAmount = () => {
    return (
      formData.selectedDonationAmount ||
      parseFloat(formData.customDonationAmount) ||
      0
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const totalAmount = getTotalAmount();
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: totalAmount,
          currency: "INR",
        }
      );

      const order = response.data;
      let sevaDescription = "Donation Payment";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Janmashtami Donation",
        description: sevaDescription,
        order_id: order.id,
        notes: {
          donorName: formData.donorName,
          donorPhoneNumber: formData.mobile,
          donorEmail: formData.email,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: { ...formData, amount: totalAmount },
              }
            );

            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              if (!isFormDataStored) {
                await storeFormData("Payment Successful");
                isFormDataStored = true;
              }
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobile,
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const totalDonationAmount = getTotalAmount();

    // Detect donation type
    const donationType = formData.customDonationAmount
      ? "Custom"
      : formData.selectedDonationAmount
        ? "Preset"
        : "None";

    const formDataToSend = new URLSearchParams();

    formDataToSend.append("paymentStatus", paymentStatus);
    formDataToSend.append(
      "selectedDonationAmount",
      formData.selectedDonationAmount || ""
    );
    formDataToSend.append(
      "customDonationAmount",
      formData.customDonationAmount || ""
    );
    formDataToSend.append("donationType", donationType);
    formDataToSend.append("totalDonationAmount", totalDonationAmount);

    formDataToSend.append("sevaDate", formData.sevaDate || "");
    formDataToSend.append("honoureeName", formData.honoureeName || "");
    formDataToSend.append("relationship", formData.relationship || "");
    formDataToSend.append("donorName", formData.donorName);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobile", formData.mobile);
    formDataToSend.append("dob", formData.dob);
    formDataToSend.append("receive80G", formData.receive80G ? "Yes" : "No");
    formDataToSend.append(
      "panNumber",
      formData.receive80G ? formData.panNumber : ""
    );
    formDataToSend.append(
      "receiveMahaPrasadam",
      formData.receiveMahaPrasadam ? "Yes" : "No"
    );
    formDataToSend.append(
      "doorNumber",
      formData.mahaPrasadamDetails.doorNumber || ""
    );
    formDataToSend.append(
      "houseName",
      formData.mahaPrasadamDetails.houseName || ""
    );
    formDataToSend.append(
      "streetName",
      formData.mahaPrasadamDetails.streetName || ""
    );
    formDataToSend.append("area", formData.mahaPrasadamDetails.area || "");
    formDataToSend.append(
      "country",
      formData.mahaPrasadamDetails.country || ""
    );
    formDataToSend.append("state", formData.mahaPrasadamDetails.state || "");
    formDataToSend.append("city", formData.mahaPrasadamDetails.city || "");
    formDataToSend.append(
      "pincode",
      formData.mahaPrasadamDetails.pincode || ""
    );

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbxvW5u4H5U2M7iPVL0JJkGwZQ7Vup3jOnDlwm4vRiUuXkrqyFiiw2h34pgADXGoP22cdQ/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formDataToSend.toString(),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      console.log("Data stored successfully in Google Sheets");
      return true;
    } catch (error) {
      console.error("Error storing data:", error);
      alert(
        "An error occurred while storing your donation details. Please try again."
      );
      return false;
    }
  };
  return (
    <div className="JForm">
      {/* Donation Form - Right Side */}
      <div className=" xl:flex xl:justify-center xl:pt-[3.5rem] mb-8 md:mt-4 mt-8 ">
        <div className="donationDetail bg-[#C61D21] py-10 px-2 rounded-3xl xl:h-full xl:p-8 xl:max-w-[800px] w-full">
          <form onSubmit={handleSubmit} className="text-white">
            <h2 className="text-center text-2xl xl:text-4xl">
              Donation Details
            </h2>

            <div className="innerForm sevaContainer">
              {/* Donation Amount Selection */}
              <div className=" p-3 rounded-md ">
                <label className="block text-black mb-2 font-semibold">
                  I would like to support:
                </label>
                <div className="grid grid-cols-2 gap-3">
                  {[30000, 60000, 150000, 300000 , 900000].map((amount) => {
                    const isSelected = formData.selectedDonationAmount === amount;
                    return (
                      <button
                        key={amount}
                        type="button"
                        className={`rounded-xl py-3 font-semibold transition 
            ${isSelected
                            ? "bg-[#d62828] text-white border-2 border-white"
                            : "bg-[#f8e7d0] text-gray-700 border-2 border-transparent"
                          }`}
                        onClick={() => handleAmountSelect(amount)}
                      >
                        ₹{amount.toLocaleString()}/-
                      </button>
                    );
                  })}
                </div>


                {/* Custom Amount Field */}
                <div className="custom-amount mt-6">
                  <label className="form-label">Donate as you wish:</label>
                  <input
                    type="number"
                    name="customDonationAmount"
                    value={formData.customDonationAmount}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        customDonationAmount: value,
                        // Clear preset selection when typing custom
                        selectedDonationAmount: null,
                      }));
                    }}
                    className="form-control"
                    placeholder="Enter custom amount"
                  />
                </div>
                {errors.donationAmount && (
                  <div className="error">{errors.donationAmount}</div>
                )}
              </div>


            </div>

            <div className="innerForm">
              <h3 className="text-center">Personal Details</h3>
              <label className="xl:w-full">
                <input
                  type="text"
                  name="donorName"
                  value={formData.donorName}
                  onChange={handleInputChange}
                  placeholder="Donor Name"
                  className="mt-2"
                />
                {errors.donorName && (
                  <span className="block -mt-2 ml-2">
                    {errors.donorName}
                  </span>
                )}
              </label>
              <label className="xl:w-full">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email ID"
                />
                {errors.email && (
                  <span className="block -mt-2 ml-2">{errors.email}</span>
                )}
              </label>
              <div className="flex gap-2">
                <label className="flex-1">
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    placeholder="Mobile Number"
                    className="p-[10px] md:w-full"
                  />
                  {errors.mobile && (
                    <span className="block mt-1 ml-2">{errors.mobile}</span>
                  )}
                </label>
                <label className="flex-1">
                  <input
                    type="text"
                    name="dob"
                    value={formData.dob}
                    onChange={handleInputChange}
                    className="text-[#909192] p-2 border rounded-md"
                    placeholder="Date Of Birth"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                  />
                  {errors.dob && (
                    <span className="block -mt-2 ml-2">{errors.dob}</span>
                  )}
                </label>
              </div>
            </div>
            <p className="text-white mt-2 text-[10px]">
              (Sankalpa and Archana will be performed for you on your
              birthday)
            </p>

            <p className="text-white -mt-2 text-xs">
              By continuing, you are agreeing to{" "}
              <a className="underline text-[#EEF9A3]">
                Terms of Use and Privacy Policy
              </a>
            </p>

            <div className="px-3 tandd mt-8">
              <label>
                <input
                  type="checkbox"
                  name="receive80G"
                  checked={formData.receive80G}
                  onChange={handle80GCheckboxChange}
                  style={{ accentColor: "blue" }}
                />
                I would like to receive 80(G) Certificate
              </label>
              {show80GDetails && (
                <div className="mb-3">
                  <p className="text-white text-[10px] text-left ml-2">
                    Finance Act 2021 mandates uploading donation details for
                    80(G) deductions. Ensure PAN and address details are
                    provided.
                  </p>
                  <input
                    type="text"
                    name="panNumber"
                    value={formData.panNumber}
                    onChange={handleInputChange}
                    placeholder="Pan Number *"
                    className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                    required
                  />
                  <input
                    type="text"
                    name="doorNumber"
                    placeholder="Door Number"
                    className="text-black"
                    value={formData.mahaPrasadamDetails.doorNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          doorNumber: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="houseName"
                    placeholder="House / Apartment / Building Name"
                    value={formData.mahaPrasadamDetails.houseName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          houseName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="streetName"
                    placeholder="Street Name"
                    value={formData.mahaPrasadamDetails.streetName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          streetName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="area"
                    placeholder="Location / Area"
                    value={formData.mahaPrasadamDetails.area}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          area: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="country"
                    placeholder="Country"
                    value={formData.mahaPrasadamDetails.country}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          country: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="state"
                    placeholder="State"
                    value={formData.mahaPrasadamDetails.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          state: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="city"
                    placeholder="City"
                    value={formData.mahaPrasadamDetails.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          city: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="pincode"
                    placeholder="Pincode"
                    value={formData.mahaPrasadamDetails.pincode}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          pincode: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              )}

              <label>
                <input
                  type="checkbox"
                  name="receiveMahaPrasadam"
                  checked={formData.receiveMahaPrasadam}
                  onChange={handleMahaPrasadamCheckboxChange}
                  style={{ accentColor: "blue" }}
                />
                I would like to receive Maha prasadam (Only within India)
              </label>
              {showMahaPrasadamDetails && (
                <div className="mt-3">
                  <input
                    type="text"
                    name="doorNumber"
                    placeholder="Door Number"
                    className="text-black"
                    value={formData.mahaPrasadamDetails.doorNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          doorNumber: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="houseName"
                    placeholder="House / Apartment / Building Name"
                    value={formData.mahaPrasadamDetails.houseName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          houseName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="streetName"
                    placeholder="Street Name"
                    value={formData.mahaPrasadamDetails.streetName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          streetName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="area"
                    placeholder="Location / Area"
                    value={formData.mahaPrasadamDetails.area}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          area: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="country"
                    placeholder="Country"
                    value={formData.mahaPrasadamDetails.country}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          country: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="state"
                    placeholder="State"
                    value={formData.mahaPrasadamDetails.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          state: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="city"
                    placeholder="City"
                    value={formData.mahaPrasadamDetails.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          city: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="pincode"
                    placeholder="Pincode"
                    value={formData.mahaPrasadamDetails.pincode}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          pincode: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              )}
            </div>

            <div className="flex justify-center mt-8">
              <button
                type="submit"
                className="bg-[#FAE29C] text-black px-12 py-3 rounded-2xl font-bold"
              >
                Donate{" "}
                {getTotalAmount() > 0
                  ? "₹ " + getTotalAmount().toLocaleString("en-IN")
                  : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default DonationForm
